<template>
  <v-dialog v-model="dialog" max-width="300">
    <ValidationObserver ref="addLabelForm" v-slot="{ invalid, passes }">
      <form
        rel="addLabelForm"
        class="flex flex-wrap justify-between sm:justify-center"
        @submit.prevent="passes(submit)"
      >
        <v-card>
          <v-card-title class="pa-7">Nový štítek</v-card-title>
          <v-card-text class="pa-7">
            <v-row>
              <v-col cols="12" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="name"
                  rules="required|order-label"
                  mode="lazy"
                  counter="20"
                  outlined
                  dense
                  label="Název"
                  data-cy="name"
                />
              </v-col> </v-row
            ><v-row>
              <v-col cols="12" class="py-0 px-5">
                <v-color-picker v-model="color" hide-inputs />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pl-7 pr-7 pb-7">
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              height="40px"
              min-width="130px"
              color="primary"
              depressed
              :loading="saving"
            >
              Uložit
            </v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import VTextFieldWithValidation from '@/components/validators/VTextFieldWithValidation'
import { mapActions } from 'vuex'
export default {
  name: 'OrderLabelAddDialog',
  components: { VTextFieldWithValidation },
  data() {
    return {
      name: null,
      color: '#ffb74d',
      saving: false,
      dialog: false,
    }
  },
  created() {
    const model = this
    this.$eventBus.$on('addLabelDialog', function (dialog) {
      model.name = null
      model.color = '#ffb74d'
      model.dialog = dialog
    })
  },
  methods: {
    ...mapActions({
      createOrderLabel: 'order/createOrderLabel',
    }),
    submit() {
      this.saving = true
      this.createOrderLabel({
        id: this.$route.params.orderId,
        name: this.name,
        color: this.color,
      }).finally(() => {
        this.saving = false
        this.$refs.addLabelForm.reset()
        this.$emit('labelAdded')
        this.close()
      })
    },
    close() {
      this.dialog = false
    },
  },
}
</script>
